import { computed, ref, toValue, watch } from 'vue'
import get from 'lodash/get'
import { FIELD_TYPE_CHOICE } from '../Constants/FieldType'

export default function ({ form, product = null, namespace = null }) {
  const selectedProduct = ref(product)

  const lockedWhenProductIsSelected = computed(() => !!selectedProduct.value)
  const createLockedIfFilled = (property) =>
    computed(() => !!selectedProduct.value && !!toValue(selectedProduct.value[property]))

  const relatedFields = [
    { property: 'supplier', readonly: lockedWhenProductIsSelected },
    { property: 'equipmentType', readonly: lockedWhenProductIsSelected },
    { property: 'productType', readonly: lockedWhenProductIsSelected },
    { property: 'unitAmount', readonly: false },
    { property: 'brand', readonly: createLockedIfFilled('brand') },
    { property: 'model', readonly: createLockedIfFilled('model') },
    { property: 'serialNumber', readonly: createLockedIfFilled('serialNumber') },
    { property: 'plate', readonly: createLockedIfFilled('plate') },
    { property: 'refId', readonly: createLockedIfFilled('refId') },
    { property: 'firstRegistrationAt', readonly: createLockedIfFilled('firstRegistrationAt') },
    { property: 'condition', readonly: lockedWhenProductIsSelected },
    { property: 'year', readonly: lockedWhenProductIsSelected },
  ].map((field) => Object.assign(field, { name: namespace ? `${namespace}.${field.property}` : field.property }))

  const readonlyFields = computed(() => relatedFields.filter(({ readonly }) => toValue(readonly)))

  function lockFields() {
    for (const { name } of readonlyFields.value) {
      form.disableField(name)
    }
  }

  function unlockFields() {
    for (const { name } of relatedFields) {
      form.enableField(name)
    }
  }

  function copyFields() {
    for (const { name, property } of relatedFields) {
      const value = get(selectedProduct.value, property, null)
      form.setFieldValue(name, value)

      const field = form.getField(name)

      if (field?.mainType === FIELD_TYPE_CHOICE && !!value) {
        form.addSelectOption(name, value)
      }
    }
  }

  watch(selectedProduct, (value) => {
    if (value) {
      copyFields()
      lockFields()
    } else {
      unlockFields()
    }
  })

  return { product: selectedProduct }
}
